<template>
<v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
<header-component headerTitle="Grading Configuration" />
<GradingConfiguration :code="username" :grade_type="'FTA Service Request'" :name="organization_name" :api="based_url" :tabs="tabs"
            :authToken="authToken" /> 
</v-card>
</template>
<script>
import HeaderComponent from "../../../../commoncomponents/HeaderComponent.vue";
import store from '@/store'
import { useRoute } from 'vue-router';
import { GradingConfiguration } from 'grading-library';
import { API_URL } from '@/backend/axios/index'; 

export default {
    name: 'GradingWithLibrary',
    components: {
        HeaderComponent,
        GradingConfiguration
    },
    data() {
        return {
            based_url: '',
            username: '',
            organization_name: ''
        }
    },
    created() {
        this.based_url = API_URL+'/api/v2';
        this.username = this.$store.state.username;
        this.organization_name = this.$store.state.organization_name;
    },
    setup() {
        const route = useRoute();
        const code = route.params.code;
        const name = route.params.name;
        const authToken = store.state.authorization;
        const tabs = ["Profile Listing", "Grade Resolution"];

        return {
            code,
            name,
            authToken,
            tabs
        };
    },
}
</script>